const isDevelopment = import.meta.env.MODE === "development";
const isTesting = import.meta.env.MODE === "testing";
const isProduction = import.meta.env.MODE === "production";
const baseUrl = import.meta.env.APP_BASE_URL;
const testBaseUrl = import.meta.env.APP_BASE_URL_TEST;

export const Config = {
  isDevelopment,
  isTesting,
  isProduction,
  baseUrl,
  testBaseUrl,
  apiUrl: import.meta.env.API_URL,
  wsUrl: import.meta.env.WS_URL,
  saWsUrl: import.meta.env.SA_WS_URL,

  Auth0: {
    domain: import.meta.env.AUTH0_DOMAIN,
    clientId: import.meta.env.AUTH0_CLIENT_ID,
    audience: import.meta.env.AUTH0_AUDIENCE,
    audienceTest: import.meta.env.AUTH0_AUDIENCE_TEST,
    clientIdTest: import.meta.env.AUTH0_CLIENT_ID_TEST,
    domainTest: import.meta.env.AUTH0_DOMAIN_TEST,
    loginWithPopup: import.meta.env.AUTH0_LOGIN_WITH_POPUP === "true",
    defaultReturnTo: "/",
  },
  Sentry: {
    Environment: import.meta.env.SENTRY_ENVIRONMENT ?? "development",
    dsn: import.meta.env.UI_SENTRY_DSN,
    tracesSampleRate: isDevelopment ? 1.0 : 0.4,
    release: import.meta.env.BUILD_VERSION,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
    ],
  },
  Userflow: {
    userflowToken: import.meta.env.USERFLOW_TOKEN,
  },
  Links: {
    SupportArticles: {
      AD_Groups_Help: import.meta.env.ADGROUP_SUPPORT_ARTICLE_URL,
    },
  },
};
